import { deleteBrowserCookie } from '@backmarket/utils/cookies/deleteBrowserCookie'
import { getBrowserCookie } from '@backmarket/utils/cookies/getBrowserCookie'
import { setBrowserCookie } from '@backmarket/utils/cookies/setBrowserCookie'
import { splitHostname } from '@backmarket/utils/url/splitHostname'
import { v4 as uuid } from 'uuid'

import {
  NETHONE_ATTEMPT_REFERENCE_COOKIE_MAX_AGE,
  NETHONE_ATTEMPT_REFERENCE_COOKIE_NAME,
} from '../config/nethone/constants'

export const getOrSetNethoneAttemptReference = () => {
  const { domain, extension } = splitHostname(window.location.host)
  const rootDomain = `${domain}.${extension}`

  const sessionId = getBrowserCookie(NETHONE_ATTEMPT_REFERENCE_COOKIE_NAME)
  if (sessionId) {
    return sessionId
  }

  const newAttemptReference = uuid()
  setBrowserCookie(NETHONE_ATTEMPT_REFERENCE_COOKIE_NAME, newAttemptReference, {
    // We want the cookie to be shared between all subdomains (accounts, www...)
    domain: rootDomain,
    maxAge: NETHONE_ATTEMPT_REFERENCE_COOKIE_MAX_AGE,
    path: '/',
  })

  return newAttemptReference
}

export const resetNethoneAttemptReference = () => {
  deleteBrowserCookie(NETHONE_ATTEMPT_REFERENCE_COOKIE_NAME)
}
